module.exports = "https://web-assets.ifttt.com/packs/media/icons/snow-8393b769.png";